import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '../../../app.service';

@Component({
  templateUrl: './dialog-loading.component.html',
  styleUrls: ['./dialog-loading.component.sass']
})
export class DialogLoadingComponent implements OnInit, OnDestroy {
  timeout: number;
  close:false
  constructor(
    public dialogRef: MatDialogRef<DialogLoadingComponent>,
    private readonly appService: AppService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.appService.closeDialogSignal$.subscribe(() => {
      //this.cancel();
    })
  }

  ok(): void {
    this.data.result = true;
  }

  cancel(): any {
    this.timeout = setTimeout(() => {
      this.dialogRef.close('close');
    }, 50)
  }

  ngOnDestroy() {
    this.timeout && clearTimeout(this.timeout);
  }
}
